import { Injectable } from '@angular/core';
import { Resolve, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CompetitionService } from 'app/services/competition.service';
import { Competition } from 'app/models/competition';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CompetitionResolver implements Resolve<Competition> {
  constructor(private competitionService: CompetitionService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Competition> {
    const competitions = this.competitionService.getCompetitions();
    let id = route.paramMap.get('id');

      if (!id) {
        id = competitions && !!competitions.length ? competitions[0].compUrl : null;
      }

    return this.competitionService.get(id).map(res => {
      this.competitionService.setCompetitionSelected(res);
      return res;
    }).catch(err => {
      return Observable.of(null);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/competition.guard.ts